export const listeordersPath = '';
export const ordersBasePath = 'commandes';
export const orderDetailPath = ':idOrder';
export const ordersFacturationPath = 'facturation/:idsOrders';
